import React from "react"

export default class RecommendCoursesTile extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		if (this.props.condensed) {
			return (
				<div className={"recommended-courses-tile recommended-courses-tile-condensed " + (this.props.viewport ? this.props.viewport : ' desktop')} style={this.props.style || {}}>
					<div className="button-wrapper">
						<a href={this.props.path} className="btn btn-primary">Get recommendations</a>
					</div>
				</div>
			);
		} else {
			return (
				<div className={"recommended-courses-tile " + (this.props.viewport ? this.props.viewport : ' desktop')} style={this.props.style || {}}>
					<h2>{I18n.t('recommended_courses_tile.heading')}</h2>
					<p>Just answer these questions to get personalized recommendations.</p>
					<div className="button-wrapper">
						<a href={this.props.path} className="btn btn-primary">Get recommendations</a>
					</div>
				</div>
			);
		}
	}

}